import type { CSSProperties } from 'react';
import { TagIconButton, TagImageButton } from '../components/tags';
import { createFilter } from '../create-filter';
import { type FilterBound, type FilterProps } from '../types';
import { arrayFilterMethods } from '../utils';

export type TagControlProps<T = string> = FilterProps<
  T[],
  {
    imageSrc?: string;
    iconSrc?: string;
    label: string;
    value: T;
    buttonStyles?: CSSProperties;
    backgroundColor?: string;
    withBackground?: boolean;
  }
>;

export const TagControl = createFilter(function UnboundTagControl({
  imageSrc,
  iconSrc,
  label,
  filter,
  value,
  withBackground,
  buttonStyles,
  backgroundColor
}: TagControlProps) {
  const TagComponent = imageSrc ? TagImageButton : TagIconButton;
  const { hasAppliedValue, toggleAppliedValue } = arrayFilterMethods(
    filter as FilterBound<string[]>
  );

  return (
    <TagComponent
      selected={hasAppliedValue(value)}
      onClick={() => toggleAppliedValue(value)}
      imageSrc={imageSrc}
      iconSrc={iconSrc}
      buttonStyles={buttonStyles}
      backgroundColor={backgroundColor}
      withBackground={withBackground}
      borderRadius={8}
    >
      {label}
    </TagComponent>
  );
});
